module.exports = __webpack_public_path__ + "img/6.0d8ec559.png";